import { render } from "./kalio-users.vue?vue&type=template&id=58f7178f"
import script from "./kalio-users.vue?vue&type=script&lang=js"
export * from "./kalio-users.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__